'use client';

// Package Imports
import React, { useState } from 'react';

// Style Imports
import styles from './modalLogin.module.scss';

// Component Imports
import Modal from "@/components/modal";
import AccountLogin from "@/components/accountLogin";

interface ModalLoginProps {
  isOpen?: boolean;
  setIsOpen?: (state: boolean) => void;
}

const ModalLogin: React.FC<ModalLoginProps> = ({ isOpen: externalIsOpen, setIsOpen: externalSetIsOpen }) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);

  // Determine which state to use
  const isModalOpen = externalIsOpen ?? internalIsOpen;
  const setModalOpen = externalSetIsOpen ?? setInternalIsOpen;

  const onLoginSuccess = () => {
    setModalOpen(false);
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setModalOpen(false)}
      enableCloseButton={true}
      enableDismiss={true}
      modalClass={styles.loginModal}
      content={
        <div className={styles.modalLogin}>
          <h1>Login</h1>
          <AccountLogin onLoginSuccess={onLoginSuccess} />
        </div>
      }
    />
  );
};

export default ModalLogin;
